import { useState, useEffect, useRef} from 'react';
import { ajaxor2, getNaturalTimeString, isLogon } from '../../common/basic';
import getNLS from '../../common/_NLS';


import FallbackModal from '../../popup/Fallback3';
import Likers from '../../popup/PersonList';

import ConfirmDelete from '../../popup/ConfirmDelete';
import CopiedMessageBox from '../../popup/SimpleMessage';

export default props=>{
  if (!props.me) return <></>;
  // console.log("infoperson : ", props.me);

  const [dLikersPopup, setDLikersPopup] = useState('none');
  const [vCurrentContentID, setCurrentContentID] = useState(null);


  const [dConfirmDelete, setConfirmDelete] = useState('none');

  const [dCopied, setCopied] = useState('none');
  const textAreaRef = useRef(null);
  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand('copy');
    e.target.focus();
    setCopied('block');
  };



  const [vScrapped, setScrapped] = useState(props.me && (props.me.collected));
  function goScrap() {
    if (!isLogon()) {
      alert('로그인을 하셔야 합니다.');
      return;
    }

    ajaxor2({
      url: '/inspiration/collect/' + props.me.id, type: 'post'
      , callback: callback
    });
    function callback(rd){
      // console.log(rd.status);
      setScrapped(rd.status == "collected");
    }
  }


  useEffect(() => {
    setScrapped(props.me && (props.me.collected));
    return () => { ; };
  }, [props.me]);

  return (<div className="InfoPerson">
    <style jsx>{`

.image {
width: 100%;
}

.l5{
font-size: 12px;
color: #868e96;
margin-top: -6px;
}

img,span {
vertical-align:middle;
}

img.chain{
  width: 24px;
}


.dib{
display: inline-block;
// margin:0;

vertical-align: middle;
}

.brief{
width:100%;
}

.brief .word{
display: inline-block;
height: 32px;
line-height: 32px;
vertical-align: middle;
font-size: 14px;

}

/* .line1{
padding: 20px 5px;
} */


.right{
float:right;
}


.edit{
  font-size:14px;
}

.Rectangle {
  display:inline-block;
  width: 1px;
  height: 8px;
  background-color: #dee2e6;
  margin: 0 0 1px 0;
}

.round-psa, .round-psa > img{
  width: 40px;
  height:40px;
}

.backtireblue{
  font-size:14px;
  height: 20px;
  line-height: 20px;
  margin: 0 0 3px 0;
}

.seven{
  font-size:12px;
  color:#868e96;
  height: 20px;
  line-height: 20px;

  vertical-align: sub;
}


`}</style>


    <div className="brief line1 dnom">

      <div className="dib">
        <a href={"/person/Blog?userid=" + (props.me && props.me.user && props.me.user.id)}><img className="round-psa"
          src={props.me.user && props.me.user.profile_picture[0] ? props.me.user.profile_picture[0].optimized_url : '/assets/images/ico-empty.svg'}
        /></a>
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <div className="dib">
        <div className="backtireblue"><a href={"/person/Blog?userid=" + (props.me && props.me.user && props.me.user.id)}>{props.me && props.me.user && props.me.user.username ? props.me.user.username : ''}</a></div>
        <div className="l5">
          {/* <img src="/assets/images/time.svg" /> */}
          <span className="seven">{props.me && props.me.created_at ? getNaturalTimeString(props.me.created_at) : ''}</span>&nbsp;&nbsp;
      </div>
      </div>

      <div className="right" >
        {
          // 로그인했고 & (로긴자가 이사람 | 로긴자가 관리자) 면, 수정/삭제
          (typeof localStorage != 'undefined' && typeof localStorage["loginer"] != 'undefined')
            && props.me.user && props.me.user.id
            && (props.me.user.id == JSON.parse(localStorage["loginer"]).id
               || (JSON.parse(localStorage["loginer"]).is_admin) // 수정삭제가 다된다는말은, 관리자로 로그인했기때문인것 같다.
            )
            ? (
              <span className="edit">
                {/* <a href={"/community/upload1?cid=" + props.me.id}>수정</a> */}
                <a href={"/community/write/change1?cid=" + props.me.id}>수정</a>
                &nbsp;&nbsp;<div className="Rectangle" />&nbsp;&nbsp;
            <a onClick={() => setConfirmDelete('block')}>삭제</a>
              </span>)
            : null
        }

        &nbsp;&nbsp;&nbsp;
        <a onClick={copyToClipboard}>
          <img className="chain" src="/assets/images/link.svg" />
        </a>

        <textarea ref={textAreaRef} 
          // value={(typeof location == 'undefined' ? '' : location.origin) + '/community/' + props.me.id
          //   + "?t1=" + encodeURI(props.me.title)
          //   + "&t3=" + encodeURI(props.me.images && props.me.images[0].low_quality_url)
          //   + "&t2=" + encodeURI(props.me.subtitle)
          // } 
          value={'https://api.camscon.kr/community/' + props.me.id} 
          style={{ width: 0, height: 0, margin: 0, border: 0, padding: "1px" }} 
          onChange={() => (null)} 
        />
      </div>

      <FallbackModal display={dConfirmDelete} hide={() => { setConfirmDelete('none') }}
        innerContent={
        <ConfirmDelete display={dConfirmDelete} hide={() => setConfirmDelete('none')}
          me={{id:props.me.id}}
        />}
      />

      <FallbackModal display={dCopied} hide={() => { setCopied('none') }}
        innerContent={<CopiedMessageBox display={dCopied} hide={() => setCopied('none')}
        />}
      />

    </div>

    <style jsx>{`
    .icon32{
      width: 32px;
      height: 32px;
    }


`}</style>

    <FallbackModal display={dLikersPopup} hide={() => setDLikersPopup('none')}
      innerContent={<Likers cid={vCurrentContentID} />}
    />
    
    <div className="">&nbsp;</div>
    <div className="brief line2 dnom">
      {/* <img className="icon32" src="/assets/images/heart.svg" />&nbsp;&nbsp; */}

{/* 
      스크랩과 달리,
      라이크는 상위라이크 처리가 없다.
      /mypage/Blog 에서 라이크가 되게하기 위해, 여기서 처리하면 바깥과 끊긴다.

      210808 마이페이지와 검색결과에서 들어간 콘텐츠에서 라이크 눌리지 않음.→하트 버튼을 누르면 라이크가 눌리지 않고 라이크를 누른 사람의 리스트가 뜸. 라이크 카운트가 있는 곳(검색결과로 예상됨)은 최대한 연동하고, 연동이 불가한 곳(마이페이지로 예상)은 스크랩 버튼만 남기고 라이크버튼을 없애기로 함.

      <a onClick={props.likePlus ? props.likePlus : () => {
        // 라이크팝업
        if (!isLogon()) {
          alert('로그인을 하셔야 합니다.');
          return;
        }

        setCurrentContentID(props.me.id);
        setDLikersPopup('block');
      }}>
        <img className="상세팝업의하트 icon32" src={
          props.me.liked ? "/assets/images-m/click.svg" : "/assets/images/heart.svg"
        } />&nbsp;&nbsp;
      </a>
*/}


      <a onClick={() => {
        // 라이크팝업
        if (!isLogon()) {
          alert('로그인을 하셔야 합니다.');
          return;
        }

        setCurrentContentID(props.me.id);
        setDLikersPopup('block');
      }}>
        <span className="lcg0805 word">{getNLS("라이크")}&nbsp;&nbsp;{props.me.like_count} </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </a>
      <span className="word">&nbsp;</span>&nbsp;&nbsp;
    <a onClick={goScrap}>
      <img className="icon32" src={
        vScrapped 
        ?"/assets/images-m/scrap_black.svg"
        :"/assets/images/scrap.svg"} 
      />&nbsp;&nbsp;
      <span className="word">{getNLS("스크랩")}</span>&nbsp;&nbsp;
    </a>
    </div>


    <style jsx>{`
.brief3 {

}

.c1{
  font-size: 16px;
  font-weight: bold;
  color: #343a40;
}

.c2{
  font-size: 12px;
  color: #868e96;
  margin-top: 3px;
}

`}</style>
    <div className="dnom">&nbsp;</div>
    <div className="brief line3">
      {/* <div className="c1">{props.me && props.me.user && props.me.user.username ? props.me.user.username : ''}</div> */}
      <div className="c1">{props.me.title}</div>
      <div className="c2">{props.me.subtitle}</div>
    </div>

  </div>);
}
